function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * @file useModal
 * // TODO: 目前Antd useModal暂不支持直接使用，后续看是否直接暴露withXXX
 */
import * as React from 'react';
import HookModal from 'antd/es/modal/useModal/HookModal';
import usePatchElement from 'antd/es/_util/hooks/usePatchElement';
import { withError, withInfo, withSuccess, withWarn, withConfirm } from 'antd/es/modal/confirm';
import { IconCheckCircleFilled, IconCloseCircleFilled, IconExclamationCircleFilled, IconInfoCircleFilled, IconCloseOutlined } from '@osui/icons';
var uuid = 0;
export var ElementsHolder = /*#__PURE__*/React.memo( /*#__PURE__*/React.forwardRef(function (_props, ref) {
  var _usePatchElement = usePatchElement(),
      _usePatchElement2 = _slicedToArray(_usePatchElement, 2),
      elements = _usePatchElement2[0],
      patchElement = _usePatchElement2[1];

  React.useImperativeHandle(ref, function () {
    return {
      patchElement: patchElement
    };
  }, [patchElement]); // eslint-disable-next-line react/jsx-no-useless-fragment

  return /*#__PURE__*/React.createElement(React.Fragment, null, elements);
}));
export var confirmFunc = function confirmFunc(func, confirmType) {
  return function (config) {
    // 优先级：函数调用 > type配置 > confirm
    var type = confirmType || config.type || 'confirm'; // 自定义icon

    if (typeof config.icon !== 'undefined') {
      return Object.assign(Object.assign({
        closeIcon: /*#__PURE__*/React.createElement(IconCloseOutlined, null)
      }, func(config)), {
        type: type
      });
    }

    var icon = /*#__PURE__*/React.createElement(IconExclamationCircleFilled, null);

    if (type === 'success') {
      icon = /*#__PURE__*/React.createElement(IconCheckCircleFilled, null);
    } else if (type === 'warning') {
      icon = /*#__PURE__*/React.createElement(IconExclamationCircleFilled, null);
    } else if (type === 'error') {
      icon = /*#__PURE__*/React.createElement(IconCloseCircleFilled, null);
    } else if (type === 'info') {
      icon = /*#__PURE__*/React.createElement(IconInfoCircleFilled, null);
    }

    return Object.assign(Object.assign({
      closeIcon: /*#__PURE__*/React.createElement(IconCloseOutlined, null)
    }, func(config)), {
      icon: icon,
      type: type
    });
  };
};
export default function useOsuiModal() {
  var holderRef = React.useRef(null); // ========================== Effect ==========================

  var _React$useState = React.useState([]),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      actionQueue = _React$useState2[0],
      setActionQueue = _React$useState2[1];

  React.useEffect(function () {
    if (actionQueue.length) {
      var cloneQueue = _toConsumableArray(actionQueue);

      cloneQueue.forEach(function (action) {
        action();
      });
      setActionQueue([]);
    }
  }, [actionQueue]); // =========================== Hook ===========================

  var getConfirmFunc = React.useCallback(function (withFunc) {
    return function hookConfirm(config) {
      var _a;

      uuid += 1;
      var modalRef = /*#__PURE__*/React.createRef();

      var closeFunc = function closeFunc() {};

      var modal = /*#__PURE__*/React.createElement(HookModal, {
        key: "modal-".concat(uuid),
        config: withFunc(config),
        ref: modalRef,
        afterClose: closeFunc
      });
      closeFunc = (_a = holderRef.current) === null || _a === void 0 ? void 0 : _a.patchElement(modal);
      return {
        destroy: function destroy() {
          function destroyAction() {
            var _a;

            (_a = modalRef.current) === null || _a === void 0 ? void 0 : _a.destroy();
          }

          if (modalRef.current) {
            destroyAction();
          } else {
            setActionQueue(function (prev) {
              return [].concat(_toConsumableArray(prev), [destroyAction]);
            });
          }
        },
        update: function update(newConfig) {
          function updateAction() {
            var _a;

            (_a = modalRef.current) === null || _a === void 0 ? void 0 : _a.update(newConfig);
          }

          if (modalRef.current) {
            updateAction();
          } else {
            setActionQueue(function (prev) {
              return [].concat(_toConsumableArray(prev), [updateAction]);
            });
          }
        }
      };
    };
  }, []);
  var fns = React.useMemo(function () {
    return {
      info: getConfirmFunc(confirmFunc(withInfo, 'info')),
      success: getConfirmFunc(confirmFunc(withSuccess, 'success')),
      error: getConfirmFunc(confirmFunc(withError, 'error')),
      warning: getConfirmFunc(confirmFunc(withWarn, 'warning')),
      confirm: getConfirmFunc(confirmFunc(withConfirm))
    };
  }, [getConfirmFunc]); // eslint-disable-next-line react/jsx-key

  return [fns, /*#__PURE__*/React.createElement(ElementsHolder, {
    ref: holderRef
  })];
}
//# sourceMappingURL=index.js.map